module.exports = __webpack_public_path__ + "interior_handing-dcae372e64f96a24a544e76203fea5b5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/interior_handing.png
// module id = 4uL5
// module chunks = client